import React from "react";
// import UploaderContainer from "../../src/taskpane/components/panels/UploaderContainer";
import FileItems from "../../src/taskpane/components/file/fileItems";
import SaveWithMetaData from "../../src/taskpane/components/directoryComponents/sharepoint/SaveToSharepoint";
import { useDispatch, useSelector } from "react-redux";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { setIsSavingInBackground } from "../../src/taskpane/redux/modules/savingInBackground";
import { SharePointInputData } from "../../src/taskpane/interfaces/props/SharePointInputData";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import savingLocationStructureModule from "../../utilities/SavingLocationStructureModule";
import DuplicateFiles from "../../src/taskpane/components/directoryComponents/oneDrive/DuplicateFiles";
import { SavingInBackgroundContent } from "../../src/taskpane/components/directoryComponents/SavingInBackgroundContent";
import { ActionButton, IPanelStyles, IStackItemStyles, IStackStyles, IStackTokens, Label, MessageBar, MessageBarButton, MessageBarType, Panel, PanelType, Stack } from "@fluentui/react";
import { resetFiles, setFiles, setOneDriveOverwriteOptionSelected } from "../../src/taskpane/redux/modules/file";
import { setSavingLocation } from "../../src/taskpane/redux/modules/savingLocation";
import { Slide, ToastContainer } from "react-toastify";
import { DatasourceValidationHelper } from "../../src/taskpane/components/helpers/datasourceValidationHelper";
import { setDatasourceValues } from "../../src/taskpane/redux/modules/datasource";
import { useFileUpload } from "../Body/useFileUpload";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { CMMultipleFilesMetaDataPanel } from "./CMMultipleFilesMetaDataPanel";
import { FileMetaData } from "../../src/taskpane/interfaces/props/FileMetaData";
import { FolderView } from "../../src/taskpane/components/helpers/folderView";
import generalModule from "../../utilities/GeneralModule";
import { FileOption } from "../../src/taskpane/interfaces/IFileOption";
import { fileCheckedToggled, updateFileName, updateIndividualFileOptionsValue } from "../../src/taskpane/components/helpers/metaDataHelper";
import { applyEmailMappingToToggledFileOption } from "../../src/taskpane/components/helpers/emailMappedFileValues";
import { IFileToUpload } from "../../src/taskpane/interfaces/IFileToUpload";
import { logger } from "../../utilities/logger";
import { editFilePropertiesButtonStyles } from "../../src/taskpane/config/controlStyles";
import { VersionSelectorMinMajOnly } from "../../src/taskpane/components/_v2/_shared/VersionSelector/VersionSelectorMinMajOnly";
import { ListItemCreationData } from "../../src/taskpane/interfaces/ListItemCreationData";
import authModule from "../../utilities/AuthModule";
import { tryEncodeUriComponent } from "../../utilities/EncodeDecode";
import { sharePointInternalFileName } from "../../src/taskpane/config/constants";
import { OneDriveOverWriteEnum } from "../../src/taskpane/components/enums/oneDriveOverWriteEnum";
import { ContentManagerCopyMoveModeEnum } from "../../src/taskpane/components/enums/ContentManagerCopyMoveModeEnum";
import { IPageSettings } from "../../src/taskpane/interfaces/IPageSettings";
import { CMEntireFolderChooseNameDialog } from "./CMEntireFolderChooseNameDialog";
import DuplicateFolders from "../../src/taskpane/components/directoryComponents/oneDrive/DuplicateFolders";
import { customToast } from "../../src/taskpane/components/CustomToast";
import { SaveMode } from "../../src/taskpane/components/enums/SaveModeEnum";
import { refrehOptionsRequest } from "../../src/taskpane/config/datasourceConstants";
import { DatasourceHelper } from "../../src/taskpane/components/helpers/dataSourceHelper";

const panelStyles: Partial<IPanelStyles> = {
  main: {
    overflow: "hidden"
  },
  content: {
    height: "calc(100vh - 50px);",
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 0
  }
}

const panelStylesWhileSaving: Partial<IPanelStyles> = {
  content: {
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 0
  }
}

const containerStackTokens: IStackTokens = {
  childrenGap: 5
};

const containerStackStyles: IStackStyles = {
  root: {
    height: "100%",
  }
};

const metadataStackItemStyles: IStackItemStyles = {
  root: {
    overflowY: "auto"
  }
};

const uploaderContainerStyles: React.CSSProperties = {
  marginLeft: 10,
  marginRight: 10,
  marginTop: 5
};

export interface ICMUploadFilesPanelProps {
  closePanel?: () => void;
  reloadGrid?: () => void;
  panelIsOpen: boolean;
  serverRelPath?: string;
}

const multipleMetaUpdateIcon = { iconName: "Edit" };

export const CMUploadFilesPanel = ({ closePanel, reloadGrid, panelIsOpen, serverRelPath }: ICMUploadFilesPanelProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const dispatch = useDispatch();

  const workingDirectories = useSelector((state: RootState) => state.workingDirectories.workingDirectories);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
  const isSavingInBackground = useSelector((state: RootState) => state.savingInBackground.isSavingInBackground);
  const oneDriveOverwriteOption = useSelector((state: RootState) => state.files.oneDriveOverwriteOption);
  const datasourceValues = useSelector((state: RootState) => state.datasource.values);
  const datasourceInitialLoad = useSelector((state: RootState) => state.datasource.initialLoad);
  const datasourceCallerId = useSelector((state: RootState) => state.datasource?.callerId);
  const datasourceItems = useSelector((state: RootState) => state.tenantInfo.datasources);
  const files = useSelector((state: RootState) => state.files.files.filter(x => x.isSelected === true));
  const canOverwrite = useSelector((state: RootState) => state.files.canOverwrite);
  const siteInfo = useSelector((state: RootState) => state.tenantInfo?.sites);
  const moveTo = useSelector((state: RootState) => state.contentManagerDirectory.moveTo);
  const userAccount = useSelector((state: RootState) => state.user?.account);

  const [inputValuesToSave, setInputValuesToSave] = React.useState<SharePointInputData[]>([]);
  const [informationProtectionId, setInformationProtectionId] = React.useState<string>(null);
  // const [showShowingSavingInBackground, setShowShowingSavingInBackground] = React.useState(false);
  const [filesUploaded, setFilesUploaded] = React.useState(files?.length > 0);
  const [isCMMultipleFilesMetaDataPanelOpen, setIsCMMultipleFilesMetaDataPanelOpen] = React.useState(false);
  const [isCurrentDirectorySPList, setIsCurrentDirectorySPList] = React.useState<boolean>(false);
  const [showCreateFolderDialog, setShowCreateFolderDialog] = React.useState(false);
  const [saveMode, setSaveMode] = React.useState<SaveMode>(SaveMode.Default);

  const [_fileOptions, _setFileOptions] = React.useState<FileOption[]>([]);
  const fileOptionsRef = React.useRef<FileOption[]>([]);
  const setFileOptions = (fileOptions: FileOption[]) => {
    fileOptionsRef.current = fileOptions;
    _setFileOptions(fileOptions);
  };

  const [checkForDuplicates, setCheckForDuplicates] = React.useState(false);
  const [autoFolderCreationEnabled, setAutoFolderCreationEnabled] = React.useState(false);

  const isInOneDrive = React.useRef(currentDirectory.type == ComponentTypes.OneDrive || currentDirectory.type == ComponentTypes.OneDriveSubFolder);
  // const fieldsLoaded = React.useRef(false);

  const { saveSharePointEmailandMetadata, saveToOneDrive, showSelectVersion, setShowSelectVersion, setSelectedCheckinType, addListItem, spHasDuplicateFiles, setSpHasDuplicateFiles, spHasDuplicateFolders, setSpHasDuplicateFolders, saveEntireEmailFolder, sharepointDataListEntireFolderIsValid } = useFileUpload();

  React.useEffect(() => {
    const workingDirectoriesAvailable: boolean = Array.isArray(workingDirectories) && workingDirectories.length > 0;
    setAutoFolderCreationEnabled(workingDirectoriesAvailable && siteInfo ? !(new FolderView(siteInfo, workingDirectories[workingDirectories.length - 1]).canViewFolder()) : false);
    setIsCurrentDirectorySPList(workingDirectoriesAvailable && workingDirectories.some(x => x.type === ComponentTypes.SharePointList));
  }, [workingDirectories, siteInfo]);

  React.useEffect(() => {
    dispatch(setOneDriveOverwriteOptionSelected(OneDriveOverWriteEnum.notSelected));
  }, []);

  // React.useEffect(() => {
  //   if (isSavingInBackground) {
  //     setShowShowingSavingInBackground(true);
  //   }
  // }, [isSavingInBackground])

  React.useEffect(() => {
    if (!generalModule.getIsMultiMetaFileUpdatePanelOpen() && datasourceValues) {
      updateMetadataPropertiesFromDataSource(datasourceValues);
    }
  }, [datasourceValues]);

  React.useEffect(() => {
    generalModule.setIsMultiMetaFileUpdatePanelOpen(false);

    savingLocationStructureModule.setSavingLocationStructure(workingDirectories);
    dispatch(
      setSavingLocation({
        display: currentDirectory?.displayName,
        webUrl: currentDirectory?.webUrl,
        directory: currentDirectory?.directory,
        teamId: workingDirectories?.find(dir => dir.teamGroupId)?.teamGroupId,
        channelId: workingDirectories?.find(dir => dir.teamChannelId)?.teamChannelId
      }, isInOneDrive.current)
    );
  }, []);

  React.useEffect(() => {
    if (fileOptionsRef.current?.length > 0) {
      const updateFileOptions = fileOptionsRef.current.map(fileOption => {
        return {
          ...fileOption,
          canOverwrite
        }
      })

      setFileOptions(updateFileOptions);
    }
  }, [canOverwrite]);

  const updateMetadataPropertiesFromDataSource = (values: any) => {
    const isMultipleValues: boolean = Array.isArray(values) && values.length > 0;
    const propertyKeys = isMultipleValues
      ? Object.keys(values[0])
      : Object.keys(values);

    if (propertyKeys.length > 0) {
      const updatedinputValuesToSave = [...inputValuesToSave];
      propertyKeys.forEach((propKey) => {
        let updatedValue: any;
        if (isMultipleValues) {
          const uniqueValues = values
            .map(value => value[propKey])
            .filter((value, index, self) => self.indexOf(value) === index);
          updatedValue = uniqueValues;
        }
        else {
          updatedValue = values[propKey];
        }
        updateDatasourceDisplayNameInputData(updatedinputValuesToSave, propKey, updatedValue, isMultipleValues);
      });
      //updateSharepointMetadataToSave(updatedinputValuesToSave, informationProtectionId);
      updateSharepointMetadataToSave(updatedinputValuesToSave, null);
    }
    dispatch(setDatasourceValues(null));
  };

  const updateDatasourceDisplayNameInputData = (
    updatedinputValuesToSave: SharePointInputData[],
    propKey: string,
    value: any,
    isMultipleValues: boolean
  ) => {
    let inputDatasourceId: number;
    let inputToUpdate = inputValuesToSave.find(
      (item) => {
        const boundName: string = item.displayName?.trim()?.toLowerCase();
        if (boundName && item.internalName !== sharePointInternalFileName && boundName === propKey.trim().toLowerCase()) {
          inputDatasourceId = datasourceCallerId && DatasourceHelper.getInputDataSource(datasourceItems, boundName, [currentDirectory?.siteDisplayName ?? ""], [currentDirectory?.DocumentLibrary ?? ""])?.id;
          return true;
        }
        return false;
      }
    );

    if (inputToUpdate) {
      const inputDatasourceCompatible: boolean = Number.isInteger(inputDatasourceId) && inputDatasourceId === datasourceCallerId;
      if (value === refrehOptionsRequest) {
        const updatedInput: SharePointInputData = inputDatasourceCompatible && updatedinputValuesToSave[inputToUpdate.index];
        if (updatedInput) {
          updatedInput.resetDatasourceOptionsToggle = !updatedInput.resetDatasourceOptionsToggle;
        }
      }
      else if (isMultipleValues || inputDatasourceCompatible) { //value param is an array
        try {
          const updatedInput: SharePointInputData = inputDatasourceCompatible && updatedinputValuesToSave[inputToUpdate.index];
          if (updatedInput) {
            if (!Array.isArray(value)) {
              value = [value];
            }
            if (updatedInput.value) {
              if (Array.isArray(updatedInput.value) && updatedInput.value.length > 0) {
                updatedInput.value = updatedInput.value
                  .map(val => {
                    if (val && value.some(x => x?.trim().toLowerCase() === val.trim().toLowerCase())) {
                      return val;
                    }
                    return null;
                  })
                  .filter(val => val);
              }
              else if (!datasourceInitialLoad) {
                if (value.length === 1) {
                  DatasourceValidationHelper.setSingleDatasourceResultValue(updatedinputValuesToSave, inputToUpdate, value[0]);
                }
                else if ((value.length > 1 && !value.some(x => x?.trim().toLowerCase() === updatedInput?.value?.trim().toLowerCase()))) {
                  updatedInput.value = null;
                }
              }
            }
            else if (value.length === 1) {
              DatasourceValidationHelper.setSingleDatasourceResultValue(updatedinputValuesToSave, inputToUpdate, value[0]);
            }
            updatedInput.updatedDatasourceOptions = value;
          }
        } catch (error) {
          logger(error, "CMUploadFilesPanel.tsx (updateDatasourceDisplayNameInputData)");
        }
      }
      else {
        DatasourceValidationHelper.setSingleDatasourceResultValue(updatedinputValuesToSave, inputToUpdate, value);
      }
    }
  };

  const onPanelCLose = () => {
    dispatch(setIsSavingInBackground(false));
    if (!moveTo.moveToEnabled) {
      dispatch(resetFiles([]));
    }
    closePanel();
  }

  const dismissSavingInBackground = () => {
    dispatch(setIsSavingInBackground(false));
    dispatch(setFiles([]));
    closePanel();
  }

  const updateSharepointMetadataToSave = (metadata: SharePointInputData[], informationProtectionId: string, changedIndex?: number) => {
    setInputValuesToSave(metadata);
    setInformationProtectionId(informationProtectionId);

    if (fileOptionsRef.current?.length > 0) {
      setFileOptions(updateIndividualFileOptionsValue(fileOptionsRef.current, metadata, changedIndex, languageStrings.TitleAutoSet));
    }
  };

  const saveToSharePoint = async (autoFolderCreation: boolean, saveMode?: SaveMode) => {
    if (moveTo.moveToEnabled && moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails) {
      if (sharepointDataListEntireFolderIsValid(inputValuesToSave)) {
        setShowCreateFolderDialog(true);
      }
    }
    else if (fileOptionsRef.current?.length > 0) {
      const fileMetaData: FileMetaData[] = fileOptionsRef.current.map(fileOption => {
        return {
          fileId: fileOption.key as string,
          name: fileOption.file.name,
          isSelected: fileOption.isSelectedFile,
          metaData: fileOption.fileInputValues
        }
      });

      saveSharePointEmailandMetadata(autoFolderCreation, inputValuesToSave, informationProtectionId, fileMetaData, undefined, undefined, undefined, (spHasDuplicateFiles || showSelectVersion), saveMode);
    }
    else if (isCurrentDirectorySPList) {
      const itemsWithErrors = inputValuesToSave.filter(item => item.hasError === true && item.internalName !== sharePointInternalFileName).map(item => item.errorMessage ? `${item.displayName} - ${item.errorMessage}` : item.displayName);

      if (itemsWithErrors.length > 0) {
        generateToastError(itemsWithErrors);
        return;
      }

      const data: ListItemCreationData = {
        accessToken: await authModule.getSharePointAccessToken(),
        tenantGuid: userAccount?.tenantId,
        accountId: userAccount?.accountId,
        siteUrl: currentDirectory.webUrl,
        parentUrl: tryEncodeUriComponent(serverRelPath),
        listId: currentDirectory.sharePointListId,
        metadata: inputValuesToSave.map(item => ({ internalName: item.internalName, value: item.value, type: item.type })),
        isFolder: false
      }

      await addListItem(data);
      dismissSavingInBackground();
    } else {
      saveSharePointEmailandMetadata(autoFolderCreation, inputValuesToSave, informationProtectionId, undefined, undefined, undefined, undefined, (spHasDuplicateFiles || showSelectVersion), saveMode);
    }
  }

  const generateToastError = (items: string[]) => {
    customToast.error(
      <div>
        <strong>{languageStrings.MetadataValidationFailed}</strong><br />
        {generateErrors(items)}
      </div>
    );
  };

  const generateErrors = (items: string[]) => {
    return items.map((item, index) => {
      return (
        <span key={index}>
          &bull; {item} <br />
        </span>
      );
    });
  };

  const saveFiles = async (saveMode: SaveMode, selectedFile: FileOption) => {
    let fileMetaData: FileMetaData[] = [];
    if (selectedFile) {
      const itemsWithErrors = selectedFile.fileInputValues.filter(item => item.hasError === true && item.internalName !== sharePointInternalFileName).map(item => item.errorMessage ? `${item.displayName} - ${item.errorMessage}` : item.displayName);

      if (itemsWithErrors.length > 0) {
        generateToastError(itemsWithErrors);
        return;
      }

      const metaData: FileMetaData = {
        fileId: selectedFile.key as string,
        name: selectedFile.file.name,
        isSelected: selectedFile.isSelectedFile,
        metaData: selectedFile.fileInputValues
      }

      fileMetaData.push(metaData);

      saveSharePointEmailandMetadata(autoFolderCreationEnabled, inputValuesToSave, informationProtectionId, fileMetaData, null, true, setSelectedIndividualFile, (spHasDuplicateFiles || showSelectVersion), saveMode);
    }
    else {
      fileMetaData = fileOptionsRef.current.map(fileOption => {
        return {
          fileId: fileOption.key as string,
          name: fileOption.file.name,
          isSelected: fileOption.isSelectedFile,
          metaData: fileOption.fileInputValues
        }
      });

      saveSharePointEmailandMetadata(autoFolderCreationEnabled, inputValuesToSave, informationProtectionId, fileMetaData, setIsCMMultipleFilesMetaDataPanelOpen, undefined, undefined, (spHasDuplicateFiles || showSelectVersion), saveMode);
    }
  }

  const resetIndividualFileInputValues = () => {
    setFileOptions([]);
  }

  const setSelectedIndividualFile = (fileId: string, isSaving: boolean, savingSuccess: boolean, savingError: boolean) => {
    setFileOptions(fileOptionsRef.current.map(fileOption => {
      if (fileOption.key === fileId) {
        return {
          ...fileOption,
          isSaving,
          savingSuccess,
          savingError
        }
      }

      return { ...fileOption }
    }))

    if (savingSuccess) {
      setCheckForDuplicates(true);
      reloadGrid();
    }
  }

  const filesNameUpdated = (file: IFileToUpload) => {
    if (fileOptionsRef.current?.length > 0) {
      setFileOptions(updateFileName(fileOptionsRef.current, file));
    }
  }

  const fileCheckedToggle = (toggledFile: IFileToUpload) => {
    if (fileOptionsRef.current?.length > 0) {
      try {
        // A re-checked email (or attachment) must get its own mapped header
        // values back — the shared-form values it is rebuilt from only carry
        // the auto-set placeholder for email-mapped columns.
        setFileOptions(applyEmailMappingToToggledFileOption(fileCheckedToggled(fileOptionsRef.current, toggledFile, canOverwrite, inputValuesToSave), toggledFile));
      } catch (error) {
        logger(error, "CMUploadFilesPanel.tsx (fileCheckedToggle)");
      }
    }
  }

  const [showUploader, setShowUploader] = React.useState(false);

  // React.useEffect(() => {
  //   if (!moveTo?.moveToEnabled &&
  //     !isCurrentDirectorySPList &&
  //     !showSelectVersion &&
  //     (!oneDriveOverwriteOption || oneDriveOverwriteOption === OneDriveOverWriteEnum.notSelected)) {
  //     setShowUploader(true);
  //   } else {
  //     setShowUploader(false);
  //   }
  // }, [moveTo, isCurrentDirectorySPList, showSelectVersion, oneDriveOverwriteOption]);

  const saveToOneDrivePre = async (
    folderName: string = "",
    fromLocationItemCurrentDirectory?: IPageSettings,
    savingLocationDirectory?: string,
    locationBeforeSaving?: IPageSettings[],
    searchedFolderLocation?: IPageSettings[],
    goToHome: boolean = false,
    saveMode?: SaveMode
  ): Promise<void> => {
    if (moveTo.moveToEnabled && moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails) {
      setShowCreateFolderDialog(true);
    } else {
      saveToOneDrive(folderName, fromLocationItemCurrentDirectory, savingLocationDirectory, locationBeforeSaving, searchedFolderLocation, goToHome, saveMode);
    }
  }

  const cancelDuplicateAndVersionOptionSelection = () => {
    setShowSelectVersion(false);
    setSpHasDuplicateFiles(false);
    setSpHasDuplicateFolders(false);
  }

  return (
    <Panel
      headerText={isCurrentDirectorySPList ? `${languageStrings.New} ${languageStrings.ListItem.toLowerCase()}` : languageStrings.UploadFiles}
      isOpen={panelIsOpen}
      onDismiss={() => onPanelCLose()}
      isLightDismiss={false}
      closeButtonAriaLabel="Close"
      type={PanelType.custom}
      customWidth={'350px'}
      styles={isSavingInBackground ? panelStylesWhileSaving : panelStyles}
    >
      {isSavingInBackground &&
        <div className="xb-content-container">
          <div className="xb-content">
            <SavingInBackgroundContent dismissPanel={dismissSavingInBackground} saveMode={saveMode} />
          </div>
        </div>}
      {!isSavingInBackground &&
        <>
          <Stack tokens={containerStackTokens} styles={containerStackStyles}>
            {files?.length > 1 && _fileOptions?.some(x => x.isModified) && <MessageBar
              messageBarType={MessageBarType.warning}
              isMultiline={false}
              dismissButtonAriaLabel="Close"
              actions={
                <div>
                  <MessageBarButton onClick={() => {
                    resetIndividualFileInputValues();
                  }}>{languageStrings.Reset}</MessageBarButton>
                </div>
              }
            >{languageStrings.IndividualFilesUpdated}</MessageBar>}
            <Stack.Item>
              <div style={uploaderContainerStyles}>
                {/* {showUploader && <UploaderContainer onComplete={onUploadComplete} onClear={onUploadClear} enableAutoUpload={true} allowMultipleFiles={true} />} */}
                {((!showSelectVersion && !spHasDuplicateFiles && !spHasDuplicateFolders && files?.length > 1 && !isInOneDrive.current && inputValuesToSave?.length > 0)
                  || (moveTo.moveToEnabled && !showSelectVersion && !spHasDuplicateFiles && !files?.some(x => x.isGraphMailItem) && moveTo.mode !== ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails))
                  && <ActionButton
                    iconProps={multipleMetaUpdateIcon}
                    styles={editFilePropertiesButtonStyles}
                    allowDisabledFocus
                    onClick={() => {
                      setIsCMMultipleFilesMetaDataPanelOpen(true);
                    }}
                    text={languageStrings.UpdateIndividualFileMetaData}
                  />}
              </div>
            </Stack.Item>
            <Stack.Item grow styles={metadataStackItemStyles}>
              {(showSelectVersion || spHasDuplicateFiles || spHasDuplicateFolders) && <div className="xb-content-lite">
                {spHasDuplicateFolders && !spHasDuplicateFiles && <DuplicateFolders showSelectVersion={showSelectVersion} onCancel={cancelDuplicateAndVersionOptionSelection} />}
                {spHasDuplicateFiles && <DuplicateFiles showSelectVersion={showSelectVersion} onCancel={cancelDuplicateAndVersionOptionSelection} hasDuplicateFolders={spHasDuplicateFolders} />}
                {showSelectVersion && <VersionSelectorMinMajOnly checkinTypeChanged={setSelectedCheckinType} onCancel={cancelDuplicateAndVersionOptionSelection} labelFontSize={16} paddingTop={0} paddingLeft={0} />}
              </div>}
              <div className={(showSelectVersion || spHasDuplicateFiles || spHasDuplicateFolders) ? "none" : "xb-content"}>
                {(moveTo.moveToEnabled || isCurrentDirectorySPList || filesUploaded) && <SaveWithMetaData
                  inputValuesToSave={inputValuesToSave}
                  updateSharepointMetadataToSave={updateSharepointMetadataToSave}
                  isCurrentDirectorySPList={isCurrentDirectorySPList}
                  isInOneDrive={isInOneDrive.current}
                ></SaveWithMetaData>}
                {/* {isInOneDrive.current && <Stack.Item grow>
                  <Stack verticalAlign="center" horizontalAlign="center" styles={loaderStackStyles}>
                    <Stack.Item align="center">
                      {files?.length > 0 && <Label disabled>{files.length} {languageStrings.FilesSelectedToUpload} </Label>}
                      {files?.length === 0 && <Label disabled>{languageStrings.NoFilesSelected}</Label>}
                    </Stack.Item>
                  </Stack>
                </Stack.Item>} */}
              </div>
            </Stack.Item>
            <Stack.Item>
              {(moveTo.moveToEnabled || isCurrentDirectorySPList || (filesUploaded || (oneDriveOverwriteOption && oneDriveOverwriteOption !== OneDriveOverWriteEnum.notSelected)))
                && <FileItems
                  saveSharePointEmailandMetadata={saveToSharePoint}
                  saveToOneDrive={saveToOneDrivePre}
                  filesNameUpdated={filesNameUpdated}
                  fileCheckedToggle={fileCheckedToggle}
                  saveMode={saveMode}
                  setSaveMode={setSaveMode}
                />}
            </Stack.Item>
          </Stack>
        </>}
      <ToastContainer autoClose={3000} hideProgressBar transition={Slide}></ToastContainer>
      {isCMMultipleFilesMetaDataPanelOpen &&
        <CMMultipleFilesMetaDataPanel
          panelIsOpen={isCMMultipleFilesMetaDataPanelOpen}
          originalInputValues={inputValuesToSave}
          closePanel={() => {
            setIsCMMultipleFilesMetaDataPanelOpen(false);
            setShowSelectVersion(false);
            setSpHasDuplicateFiles(false);
            setSpHasDuplicateFolders(false);
          }}
          fileOptions={_fileOptions}
          setFileOptions={setFileOptions}
          saveFiles={saveFiles}
          checkForDuplicates={checkForDuplicates}
          setCheckForDuplicates={setCheckForDuplicates}
          showSelectVersion={showSelectVersion}
          spHasDuplicateFiles={spHasDuplicateFiles}
          setSelectedCheckinType={setSelectedCheckinType}
          onCancel={(selectedFile: FileOption) => {
            setShowSelectVersion(false);
            setSpHasDuplicateFiles(false);
            setSpHasDuplicateFolders(false);
            setSelectedIndividualFile(selectedFile.key?.toString(), false, false, false);
          }}
          saveMode={saveMode}
          setSaveMode={setSaveMode}
        />}
      {showCreateFolderDialog &&
        <CMEntireFolderChooseNameDialog
          showDialog={showCreateFolderDialog}
          closeDialog={() => {
            setShowCreateFolderDialog(false);
          }}
          closeOnSelection={async (folderName: string) => {
            setShowCreateFolderDialog(false);
            saveEntireEmailFolder(autoFolderCreationEnabled, inputValuesToSave, isInOneDrive.current, folderName);
            closePanel();
          }}
        />}
    </Panel>
  )
}